import React from 'react';
import { brokerSelectors, useConnectedBrokers, useAllAccounts } from '../../store/brokerStore';
import { useAccountStatsStore } from '../../store/accountStatsStore';
import './AccountStatsOverlay.css';

// Format currency compact (no decimals for large numbers)
const formatCurrency = (value: number): string => {
  return `$${value.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
};

const AccountStatsOverlay: React.FC = React.memo(() => {
  const connectedBrokers = useConnectedBrokers();
  const activeBroker = brokerSelectors.useActiveBroker();
  const allAccounts = useAllAccounts();
  const accountStatsMap = useAccountStatsStore((state) => state.accounts);

  // Don't show if no brokers connected
  if (connectedBrokers.length === 0 || !activeBroker) {
    return null;
  }

  // Get selected account's balance
  const selectedBalance = activeBroker.selectedAccountId
    ? (activeBroker.accountBalances?.[activeBroker.selectedAccountId] || activeBroker.balance)
    : activeBroker.balance;

  // Get account stats for profit target
  const statsKey = `${activeBroker.id}:${activeBroker.selectedAccountId}`;
  const stats = accountStatsMap.get(statsKey);
  const profitTarget = stats?.profitTargetEval || null;
  const startingBalance = stats?.startingBalance || 0;
  const currentBalance = selectedBalance?.netLiq || stats?.currentBalance || 0;
  const profitSoFar = startingBalance > 0 ? currentBalance - startingBalance : 0;
  const toTarget = profitTarget ? profitTarget - profitSoFar : null;

  // Count total brokers and accounts
  const totalBrokers = connectedBrokers.length;
  const totalAccounts = allAccounts.length;

  return (
    <div className="account-stats-overlay">
      <div className="account-stats-content">
        <div className="account-stats-item">
          <span className="account-stats-value">{totalBrokers}B / {totalAccounts}A</span>
        </div>
        <div className="account-stats-item">
          <span className="account-stats-label">BAL:</span>
          <span className="account-stats-value">
            {selectedBalance ? formatCurrency(selectedBalance.netLiq) : '-'}
          </span>
        </div>
        <div className="account-stats-item">
          <span className="account-stats-label">TO TARGET:</span>
          <span className={`account-stats-value ${toTarget !== null ? (toTarget <= 0 ? 'profit' : '') : ''}`}>
            {toTarget !== null
              ? toTarget <= 0
                ? '✓ PASS'
                : formatCurrency(toTarget)
              : '-'}
          </span>
        </div>
      </div>
    </div>
  );
});

export default AccountStatsOverlay;
